var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49902 9.58594H12.499",
    stroke: "#1E201C",
    strokeWidth: 1.04167,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74902 12.9141H11.249",
    stroke: "#1E201C",
    strokeWidth: 1.04167,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.249 4.58594L15.4157 18.3359H4.58236L3.74902 4.58594",
    stroke: "#1E201C",
    strokeWidth: 1.04167,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 4.58073H6.66797M6.66797 4.58073L7.91797 1.66406H12.0846L13.3346 4.58073M6.66797 4.58073H13.3346M18.3346 4.58073H13.3346",
    stroke: "#1E201C",
    strokeWidth: 1.04167,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinIcon);
export default __webpack_public_path__ + "static/media/bin-icon.91021c59b595cef1f83ec53f9a5bbcdc.svg";
export { ForwardRef as ReactComponent };